import _ from 'lodash'
import DataGridRow from './DataGridRow'

export const CellBelong = { // cell 属于
  BODY: 0,
  HEADER: 1,
  ROW_FOOTER: 2,
}

/**
 * mixin for DataGridBody & DataGridHeader
 */
export default {
  data() {
    return {
      cellBelong: CellBelong.BODY,
    }
  },
  computed: {
    context() {
      let parent = this.$parent
      while (parent && !parent.dataGridId) {
        parent = parent.$parent
      }
      return parent
    },
    store() {
      return this.context.store
    },
    layout() {
      return this.context.layout
    },
    data() {
      return this.store.data
    },
    scrollbarSize() {
      return this.layout.nativeScrollbarSize
    },
    leftFixedColumns() {
      return this.layout.leftFixedColumns
    },
    rightFixedColumns() {
      return this.layout.rightFixedColumns
    },
    centerColumns() {
      return this.layout.centerColumns
    },
    leftWidth() {
      return this.layout.renderLeftWidth
    },
    rightWidth() {
      return this.layout.renderRightWidth
    },
    centerWidth() {
      return this.layout.renderCenterWidth
    },
    scrollLeft() {
      return this.layout.scrollLeft
    },
    showLeftLine() {
      return this.scrollLeft > 0
    },
    showRightLine() {
      return this.scrollLeft + this.layout.centerViewWidth !== this.centerWidth
    },
    header() {
      return this.cellBelong === CellBelong.HEADER
    },
    rowFooter() {
      return this.cellBelong === CellBelong.ROW_FOOTER
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    handleRowClick(row) {
      this.store.apiHandleRowClick(row)
    },
    renderDataGridRow(rowIndex, rowData, columns) {
      const events = {}

      if (this.cellBelong === CellBelong.BODY) {
        events.clickRow = this.handleRowClick
      }

      return <DataGridRow
        key={rowIndex}
        rowIndex={rowIndex}
        columns={columns}
        rowData={rowData}
        {...{ on: events }}
      />
    },
    renderCenterColumns() {
      const style = {}
      const events = {}

      if (this.header || this.rowFooter) {
        _.assign(style, {
          marginLeft: this.leftWidth + 'px',
          marginRight: this.rightWidth + 'px',
          marginBottom: -(this.scrollbarSize + 20) + 'px',
          paddingBottom: '20px',
          overflowX: 'scroll',
        })

        _.assign(events, {
          // scroll: this.handleScroll,
          scroll: () => {
            console.log('scrolling....')
          },
        })
      } else {
        _.assign(style, {
          paddingLeft: this.leftWidth + 'px',
          paddingRight: this.rightWidth + 'px',
          width: this.centerWidth + this.leftWidth + this.rightWidth + 'px',
        })
      }

      const css = {
        'km-data-grid__columns': true,
        'km-data-grid__row': this.header || this.rowFooter,
      }

      const attrs = {}

      const data = {
        style: style,
        class: css,
        attrs: attrs,
        on: events,
        ref: 'scrollContainer',
      }

      if (this.header) {
        return (
          <div {...data}>
            {_.map(this.centerColumns, (column, colIndex) => column.apiRenderHeaderCell({ colIndex }))}
          </div>
        )
      }

      if (this.rowFooter) {
        return <div {...data}>
          {_.map(this.centerColumns, (column, colIndex) => column.apiRenderRowFooterCell({ colIndex }))}
        </div>
      }

      return (
        <div {...data}>
          {_.map(this.data, (rowData, rowIndex) => {
            return this.renderDataGridRow(rowIndex, rowData, this.centerColumns)
          })}
        </div>
      )
    },
    renderFixedColumns(isRight = false) {
      const keyword = isRight ? 'right' : 'left'

      if (!this[`${keyword}FixedColumns`].length) {
        return null
      }

      const style = {
        width: this[`${keyword}Width`] + 'px',
      }

      if (this.scrollLeft && !this.header && !this.rowFooter) {
        style.transform = `translateX(${this.scrollLeft}px)`
      }

      // if (this.header && isRight && this.hasVerticalScrollbar) {
      //   style.width = this[`${keyword}Width`] + this.scrollbarSize + 'px'
      // }

      const css = {
        'km-data-grid__fixed-columns': true,
        [`km-data-grid__fixed-columns--${keyword}`]: true,
        'km-data-grid__fixed-columns--left-line': !isRight && this.showLeftLine,
        'km-data-grid__fixed-columns--right-line': isRight && this.showRightLine,
        'km-data-grid__row': this.header || this.rowFooter,
      }

      const attrs = {}

      const events = {}

      const data = {
        style: style,
        class: css,
        attrs: attrs,
        on: events,
      }

      if (this.header) {
        return (
          <div {...data}>
            {_.map(this[`${keyword}FixedColumns`], (column, colIndex) => column.apiRenderHeaderCell({ colIndex }))}
            {isRight
              // 滚动条占位
              ? <div
                class="km-data-grid__col"
                style={{ width: this.scrollbarSize + 'px' }}
              >
              </div>
              : null
            }
          </div>
        )
      }

      if (this.rowFooter) {
        return (
          <div {...data}>
            {_.map(this[`${keyword}FixedColumns`], (column, colIndex) => column.apiRenderRowFooterCell({ colIndex }))}
            {isRight
              // 滚动条占位
              ? <div
                class="km-data-grid__col"
                style={{ width: this.scrollbarSize + 'px' }}
              >
              </div>
              : null
            }
          </div>
        )
      }

      return (
        <div {...data}>
          {_.map(this.data, (rowData, rowIndex) => {
            return this.renderDataGridRow(rowIndex, rowData, this[`${keyword}FixedColumns`])
          })}
        </div>
      )
    },
  },
}
